export const adminBlockConstants = {
  urlHint:
    'Custom links must be a relative path (like /animals) or start with “http://”, “https://”, “mailto:”, or “tel:',
  promoImageUrlHint: 'Custom links must start with “http://”, or “https://',
  indexPhoto: 'Index Photo',
  thumbnailPhoto: 'Thumbnail Photo'
}

export const fourDConstants ={
  fourDTitle: '4-D Experiences',
  fourDDescription:
    'Immersive visuals, mists, scents and more surprises are waiting at a 4-D Experience.',
  fourDLearnMore: 'Learn More.'
}
